// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var ThankYou$ReactHooksTemplate = require("../ThankYou.res.js");
var RichTextEditor$ReactHooksTemplate = require("../../common/RichTextEditor.res.js");

function ThankYouPageEditorCard(props) {
  var onThankYouChange = props.onThankYouChange;
  var thankYou = props.thankYou;
  var titleLen = Utils$ReactHooksTemplate.stripHtml(ThankYou$ReactHooksTemplate.title(thankYou)).length;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: "QUESTION CONTENT",
                            className: "sb-edit-card-kicker"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("span", {
                                            children: "Title"
                                          }),
                                      JsxRuntime.jsx("span", {
                                            children: String(titleLen) + (" / " + String(100)),
                                            className: "sb-field-count"
                                          })
                                    ],
                                    className: "sb-field-label"
                                  }),
                              JsxRuntime.jsx(RichTextEditor$ReactHooksTemplate.make, {
                                    value: ThankYou$ReactHooksTemplate.title(thankYou),
                                    onChange: (function (html) {
                                        Curry._1(onThankYouChange, ThankYou$ReactHooksTemplate.setTitle(thankYou, html));
                                      }),
                                    placeholder: "Enter Title",
                                    label: "",
                                    minHeight: "48px",
                                    singleLine: true,
                                    showAlignment: false,
                                    showLists: false
                                  })
                            ],
                            className: "sb-field-group"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("span", {
                                          children: "Message (Optional)"
                                        }),
                                    className: "sb-field-label"
                                  }),
                              JsxRuntime.jsx(RichTextEditor$ReactHooksTemplate.make, {
                                    value: ThankYou$ReactHooksTemplate.text(thankYou),
                                    onChange: (function (html) {
                                        Curry._1(onThankYouChange, ThankYou$ReactHooksTemplate.setText(thankYou, html));
                                      }),
                                    placeholder: "Enter message",
                                    label: "",
                                    minHeight: "96px"
                                  })
                            ],
                            className: "sb-field-group"
                          })
                    ],
                    className: "sb-edit-card",
                    onClick: (function ($$event) {
                        $$event.stopPropagation();
                      })
                  }),
              className: "sb-center-editor"
            });
}

var make = ThankYouPageEditorCard;

exports.make = make;
/* react/jsx-runtime Not a pure module */
